'use strict';

const BaseStore = require('fluxible/addons/BaseStore');
const PrivateTransaction = require('bunsen/models/ecomm/PrivateTransaction');
const TransactionValidator = require('bunsen/validation/deprecated/validators/ecom/4.3/TransactionValidator');
const Party = require('bunsen/models/Party');

class ContactTransactionStore extends BaseStore {

    doneLoading(payload) {
        const { user, item } = payload;
        if (!item) {
            return;
        }
        this.transaction = new PrivateTransaction({
            buyer: user,
            seller: item.get('seller'),
            item
        });
        this.offer = this.transaction.get('offers[0]');
        if (user) {
            this.offer.set('amountPerItem.currency', user.get('profile.currency'));
        } else {
            this.offer.set('initiatingParty', new Party({role: Party.ROLE_BUYER}));
            this.offer.set('amountPerItem.currency', this.dispatcher.getStore('UserStore').getCurrency());
        }
        this.emitChange();
    }

    editOffer(payload) {
        this.offer.set(payload.field, payload.value);
        this.emitChange();
    }

    userAuth({user, isTransaction = true}) {
        if (!this.transaction) {
            return;
        }
        if (isTransaction) {
            this.transaction.set('buyer', user);
            this.emitChange();
        }
    }

    prepareToSave() {
        if (!this.transaction) {
            return;
        }
        this.offer.set('amountPerItem.amount',
            new TransactionValidator().parseOffer(this.transaction) + ''
        );
        this.transaction.prepareToSaveBuyer();
    }
}

ContactTransactionStore.storeName = 'ContactTransactionStore';
ContactTransactionStore.handlers = {
    'contact:loading:done': 'doneLoading',
    'contact:offer:fieldEdited': 'editOffer',
    'contact:auth:done': 'userAuth',
    'contact:form:offer:valid': 'prepareToSave',
    'pdp:contact:loading:done': 'doneLoading'
};

module.exports = ContactTransactionStore;



// WEBPACK FOOTER //
// ./assets/js/contact/shared/stores/ContactTransactionStore.es.js